import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import { IColors } from '@src/types/theme';
import { getColorTheme } from '@src/store/selectors/theme';

import { DueDateIcon } from '@src/components/common/icon';

const SoldOutWrapper = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
`;

const SoldOutContent = styled.div`
	margin-left: 12px;
`;

const SoldOutText = styled.div`
	margin-bottom: 4px;
	font-size: 14px;
`;

const SoldOutDescription = styled.div`
	font-size: 24px;
	color: #101010;
`;

interface ISlotSelection {
	className?: string;
}

const SoldOut = ({ className }: ISlotSelection): JSX.Element => {
	const { t } = useTranslation();
	const { colors } = useSelector(getColorTheme) as { colors: IColors };

	return (
		<SoldOutWrapper className={className}>
			<DueDateIcon mainColor={colors.primary} />
			<SoldOutContent>
				<SoldOutText>{t('event:sold_out')}</SoldOutText>
				<SoldOutDescription>{t('event:forward_to_see_you')}</SoldOutDescription>
			</SoldOutContent>
		</SoldOutWrapper>
	);
};

export default SoldOut;
